import { PATIENT_CONTEXT_TYPE } from '../../../../../util/patientContextUtil';
import PatientContextButtonRender from './patientContextButtonRender';
import RenderActivityButtonInfo from './renderActivityButtonInfo';
import { getConfig } from '../../../../../util/configUtil';
import BedRequestButton from '../../../forms/csm/bedRequestButton';
import React from 'react';

const bedRequestModuleEnabled = getConfig('modules.bedManagement.bedRequest', false);
const oldBedRequest = getConfig('modules.forms.bedBooking.enableBedRequestForm', false);
const initialAssessmentEnabled = getConfig('modules.forms.initialAssessment.enabled', false);

export const getPatientMainScreenButtons = (patient, patientType, disableSave) => {
    switch (patientType) {
        case PATIENT_CONTEXT_TYPE.ED:
        case PATIENT_CONTEXT_TYPE.SDEC:
        case PATIENT_CONTEXT_TYPE.UTC:
            return getEDButtons(patient, patientType, disableSave);
        case PATIENT_CONTEXT_TYPE.EDAU:
            return getEDAUButtons(patient, disableSave);
        case PATIENT_CONTEXT_TYPE.INPATIENT:
            return getIPButtons(patient, disableSave);
        case PATIENT_CONTEXT_TYPE.REVIEW:
            return null;

        default:
            console.error('WRONG PATIENT TYPE', patientType, patient);
            return {
                firstCol: [],
                secondCol: [],
                thirdCol: [],
            };
    }
};

const getCsmButton = (patient, disableSave) => {
    return <PatientContextButtonRender type={oldBedRequest ? 'bedRequest' : 'csm'} patient={patient} disableSave={disableSave} />;
};

const getEDButtons = (patient, patientType, disableSave) => {
    const bedRequestButton = bedRequestModuleEnabled ? <BedRequestButton patient={patient} /> : getCsmButton(patient, disableSave);
    const initialAssessmentButton = initialAssessmentEnabled ? (
        <PatientContextButtonRender key="initialAssessment" type="initialAssessment" patient={patient} disableSave={disableSave} />
    ) : (
        <PatientContextButtonRender key="firstClinician" type="firstClinician" patient={patient} disableSave={disableSave} />
    );

    const firstUpperCol = [
        <RenderActivityButtonInfo key="activity" patient={patient} patientType={patientType} />,
        bedRequestButton,
        <PatientContextButtonRender key="clinicalConclusion" type="clinicalConclusion" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="msgToGp" type="msgToGp" patient={patient} disableSave={disableSave} />,
    ];
    const secondUpperCol = [
        <PatientContextButtonRender key="currentClinician" type="currentClinician" patient={patient} disableSave={disableSave} />,
        initialAssessmentButton,
        <PatientContextButtonRender key="rapidAssessment" type="rapidAssessment" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="seniorReview" type="seniorReview" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="handover" type="handover" patient={patient} disableSave={disableSave} />,
    ];
    const thirdUpperCol = [
        <PatientContextButtonRender key="dependency" type="dependency" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="triage" type="triage" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="seeAndTreat" type="seeAndTreat" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="clerkingED" type="clerkingED" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="referrals" type="referrals" patient={patient} disableSave={disableSave} />,
    ];

    return {
        firstCol: firstUpperCol,
        secondCol: secondUpperCol,
        thirdCol: thirdUpperCol,
    };
};

const getEDAUButtons = (patient, disableSave) => {
    const bedRequestButton = bedRequestModuleEnabled ? <BedRequestButton patient={patient} /> : getCsmButton(patient, disableSave);

    const firstUpperCol = [
        <RenderActivityButtonInfo key="activity" patient={patient} patientType={PATIENT_CONTEXT_TYPE.EDAU} />,
        bedRequestButton,
        <PatientContextButtonRender key="clinicalConclusion" type="clinicalConclusion" patient={patient} disableSave={disableSave} />,
    ];
    const secondUpperCol = [
        <PatientContextButtonRender key="currentClinician" type="currentClinician" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="currentNurse" type="currentNurse" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="seniorReview" type="seniorReview" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="handover" type="handover" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="nurseHandover" type="nurseHandover" patient={patient} disableSave={disableSave} />,
    ];
    const thirdUpperCol = [
        <PatientContextButtonRender key="dependency" type="dependency" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="nursingChecklist" type="nursingChecklist" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="medicalChecklist" type="medicalChecklist" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="referrals" type="referrals" patient={patient} disableSave={disableSave} />,
    ];

    return {
        firstCol: firstUpperCol,
        secondCol: secondUpperCol,
        thirdCol: thirdUpperCol,
    };
};

const getIPButtons = (patient, disableSave) => {
    const bedRequestButton = bedRequestModuleEnabled ? <BedRequestButton patient={patient} /> : getCsmButton(patient, disableSave);

    const firstUpperCol = [
        <RenderActivityButtonInfo key="activity" patient={patient} patientType={PATIENT_CONTEXT_TYPE.INPATIENT} />,
        bedRequestButton,
    ];
    const secondUpperCol = [
        <PatientContextButtonRender key="currentClinicianIP" type="currentClinicianIP" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="currentNurseIP" type="currentNurseIP" patient={patient} disableSave={disableSave} />,
    ];
    const thirdUpperCol = [
        <PatientContextButtonRender key="clerkingIP" type="clerkingIP" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="intendentManagement" type="intendentManagement" patient={patient} disableSave={disableSave} />,
        <PatientContextButtonRender key="boardRound" type="boardRound" patient={patient} disableSave={disableSave} />,
    ];

    return {
        firstCol: firstUpperCol,
        secondCol: secondUpperCol,
        thirdCol: thirdUpperCol,
    };
};
